import React, { useState, useEffect } from "react";
import { MultiInputFilter } from "app/NativeComponents/snippets";
import { useDispatch, useSelector } from "react-redux";

const MultiZipFilter = ({ filter_search, editLeadFilter }) => {
  const { filters } = useSelector(state => state.filter);
  return (
    <MultiInputFilter
      filter_title="Property Address Zip Code(s)"
      filter_value={filters.filter_property_zip}
      filter_prop={"filter_property_zip"}
      filter_search={filter_search}
      editLeadFilter={editLeadFilter}
      createTagOnLength={5}
      textInputKeyboardType={"number-pad"}
    />
  );
};

export default MultiZipFilter;
